document.addEventListener('DOMContentLoaded', function() {
  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function(event) {
    const { html, sectionId } = event.data;
    
    // Get the updated overview from the fetched HTML
    const newOverview = html.querySelector('.product-overview__content');
    // Get the current overview on the page
    const currentOverview = document.querySelector('.product-overview__content');
    
    if (newOverview && currentOverview) {
      currentOverview.innerHTML = newOverview.innerHTML;
    }
  });
});
